import { FaGraduationCap } from 'react-icons/fa';
import { LiaSchoolSolid } from "react-icons/lia";
import { HiBuildingOffice2 } from "react-icons/hi2";
import { BsFillSuitSpadeFill } from "react-icons/bs";
const timelineItems = [
  // {
  //   date: <span className='text-lightText md:text-darkBg dark:text-lightText'> 2023 SEP - Present </span>,
  //   position: 'right',
  //   icon: <FaBriefcase />,
  //   title: 'Integrated Active Monitoring',
  //   subTitle: 'Software Developer',
  //   description: 'React JS, Redux Toolkit, Ant Design, FastAPI, Python, PSQL, MongoDB, Docker',
  // },
  {
    date: <span className='text-lightText md:text-darkBg dark:text-lightText'> 2021 </span>,
    position: 'left',
    icon: <LiaSchoolSolid  />,
    title: 'OPJS, Raigarh',
    // subTitle: 'PCM + IP',
    // description: 'Overall 12th Percentage - 87%',
  },
  {
    date: <span className='text-lightText md:text-darkBg dark:text-lightText'> 2021 - 2025 </span>,
    position: 'right',
    icon: <FaGraduationCap />,
    title: 'GHRCE, Nagpur',
    subTitle: ' B.Tech - CSE',
    // description: 'Under Graduation (B.Tech CSE)',
  },
  {
    date: <span className='text-lightText md:text-darkBg dark:text-lightText'>2024 JUN - 2024 JUL</span>,
    position: 'left',
    icon: <HiBuildingOffice2 />,
    title: 'Byte Uprise',
    subTitle: 'Web Developer Intern, Nagpur',
    // description: 'HTML, CSS, JavaScript',
  },
  {
    date: <span className='text-lightText md:text-darkBg dark:text-lightText'>Nov'24 - Jun'25</span>,
    position: 'right',
    icon: <HiBuildingOffice2 />,
    title: ' HB Gadget Technology & Solution Pvt. Ltd.',
    subTitle: 'React FullStack Developer Intern, Nagpur',
    description: 'React JS, TypeScript, Tailwind CSS,Rest API, Socket.IO, MongoDB, NodeJS, ExpressJS, Firebase, Redux Toolkit & Many More',
  },
  {
    date: <span className='text-lightText md:text-darkBg dark:text-lightText'>Jul'25 - Present</span>,
    position: 'left',
    icon: <BsFillSuitSpadeFill  />,
    title: 'Capgemini Technology Services India Limited.',
    subTitle: 'Integration Developer, Hyderabad',
    description: 'Mulesoft ESB, Boomi, Anypoint platform, Salesforce, Azure and AWS cloud, ActiveMQ, Redis, System and Cloud Integration, Modern API Migrations, Agents and Automation, Data Integration, API Management, and many more',
  },
];


export default timelineItems